import React from "react";
import {css} from "@emotion/react";

import {PanelExpandable} from "@pg-design/expandable-module";
import {ChevronDownIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {FOOTER_TEST_IDS} from "@pg-mono/e2e-test-utils/src/rp/common/test_id";

export interface IProps {
    children: React.ReactNode;
    title: string;
    alwaysOpen?: boolean;
    className?: string;
}

export const FooterPanelExpandable: React.FC<IProps> = (props) => {
    return (
        <PanelExpandable
            css={panelStyle}
            alwaysOpen={props.alwaysOpen}
            className={props.className}
            headerCss={headerStyle}
            title={
                <Text variant="headline_6" as="h4" dataTestId={FOOTER_TEST_IDS.PANEL_EXPANDABLE}>
                    {props.title}
                </Text>
            }
            panelArrowIcon={<ChevronDownIcon size="2.2" fill="#fff" />}
        >
            {props.children}
        </PanelExpandable>
    );
};

const headerStyle = {
    paddingBottom: "2.4re"
};

const panelStyle = css`
    color: #fff;
`;
import React from "react";
import {css} from "@emotion/react";

import {PanelExpandable} from "@pg-design/expandable-module";
import {ChevronDownIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {FOOTER_TEST_IDS} from "@pg-mono/e2e-test-utils/src/rp/common/test_id";

export interface IProps {
    children: React.ReactNode;
    title: string;
    alwaysOpen?: boolean;
    className?: string;
}

export const FooterPanelExpandable: React.FC<IProps> = (props) => {
    return (
        <PanelExpandable
            css={panelStyle}
            alwaysOpen={props.alwaysOpen}
            className={props.className}
            headerCss={headerStyle}
            title={
                <Text variant="headline_6" as="h4" dataTestId={FOOTER_TEST_IDS.PANEL_EXPANDABLE}>
                    {props.title}
                </Text>
            }
            panelArrowIcon={<ChevronDownIcon size="2.2" fill="#fff" />}
        >
            {props.children}
        </PanelExpandable>
    );
};

const headerStyle = {
    paddingBottom: "2.4re"
};

const panelStyle = css`
    color: #fff;
`;
